export class FormlySectionPricebookMapping {

  priceBookEntryDocId: string;
  formlyTextboxGuid: string;

  public constructor(init?: Partial<FormlySectionPricebookMapping>) {
    Object.assign(this, init);
  }
}
